import jsPDF from "jspdf";
import "./Css/InsuranceForm.css";
import html2canvas from "html2canvas";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import "./Css/PrintEqunry.css";
import { APL_LINK } from "../ServiceConnection/serviceconnection";
import Loader from "./Loader";

// ForwardRef to pass the ref from parent to child
const DrivingLicenseDownload = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);

  const handlePrint = () => {
    window.print();
  };

  const data = props.downloadForm2;
  const DrivingLicenseImg = props.DringImg; // Single driving license image
  const SignImg = props.SignImg;

  console.log(DrivingLicenseImg, data);

  // Function to load image and return as base64
  const loadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = (error) => {
        console.error("Image load error:", error);
        reject(error);
      };
      img.src = src;
    });
  };

  // Function to check if image is SVG
  const isSVG = (filename) => {
    return filename.toLowerCase().endsWith(".svg");
  };

  // Function to convert SVG to canvas
  const svgToCanvas = async (svgUrl) => {
    return new Promise((resolve, reject) => {
      fetch(svgUrl)
        .then((response) => response.text())
        .then((svgText) => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const img = new Image();

          const blob = new Blob([svgText], { type: "image/svg+xml" });
          const url = URL.createObjectURL(blob);

          img.onload = () => {
            canvas.width = img.width || 800;
            canvas.height = img.height || 600;
            ctx.fillStyle = "#FFFFFF";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(url);
            resolve(canvas);
          };

          img.onerror = reject;
          img.src = url;
        })
        .catch(reject);
    });
  };

  const handleDownloadPDF = async () => {
    if (!data || Object.keys(data).length === 0) {
      console.warn("Data not ready yet.");
      return;
    }

    if (!DrivingLicenseImg) {
      alert("No driving license image found to download.");
      return;
    }

    setLoading(true);

    try {
      // Create PDF with compression options
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true,
      });

      const imageUrl = `${APL_LINK}/${DrivingLicenseImg}`;

      console.log("Loading driving license image:", imageUrl);

      try {
        let canvas;

        // Check if image is SVG
        if (isSVG(DrivingLicenseImg)) {
          console.log("Processing SVG:", DrivingLicenseImg);
          canvas = await svgToCanvas(imageUrl);
        } else {
          // Load regular image (JPEG, PNG, etc.)
          const img = await loadImage(imageUrl);

          // Create a canvas to draw the image
          canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");

          // Fill white background
          ctx.fillStyle = "#FFFFFF";
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          // Draw image
          ctx.drawImage(img, 0, 0);
        }

        // Convert to base64
        const imgData = canvas.toDataURL("image/jpeg", 0.95);

        // Calculate dimensions to fit A4 page with proper aspect ratio
        const pageWidth = 190; // A4 width minus margins (210 - 20)
        const pageHeight = 277; // A4 height minus margins (297 - 20)

        let imgWidth = pageWidth;
        let imgHeight = (canvas.height * imgWidth) / canvas.width;

        // If image is too tall, scale based on height instead
        if (imgHeight > pageHeight) {
          imgHeight = pageHeight;
          imgWidth = (canvas.width * imgHeight) / canvas.height;
        }

        // Center the image
        const xOffset = (pageWidth - imgWidth) / 2 + 10;
        const yOffset = 10;

        // Add image to PDF
        pdf.addImage(imgData, "JPEG", xOffset, yOffset, imgWidth, imgHeight);

        // Add document information at the bottom
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(
          `Driving License | Driver Name: ${
            data?.first_name + " " + data?.last_name
          } | Car Number: ${data?.car_data[0]?.car_tagline}`,
          10,
          287
        );

        // Add filename
        pdf.setFontSize(8);
        pdf.text(`File: ${DrivingLicenseImg}`, 10, 292);

        // Set PDF properties
        pdf.setProperties({
          title: "Driving License",
          subject: "Driver License Document",
          creator: "Rapid Car Leasing",
          author: "System",
        });

        // Generate filename
        const fileName = `${data?.first_name || ""}_${
          data?.last_name || ""
        }_DrivingLicense_${
          data?.car_data?.[0]?.car_tagline || ""
        }_.pdf`;

        // Save PDF
        pdf.save(fileName.replace(/\s+/g, "_"));

        setLoading(false);
      } catch (error) {
        console.error(`Error loading driving license image:`, error);
        alert("Failed to load driving license image. Please try again.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Error generating PDF. Please try again.");
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    handleDownloadPDF: () => {
      if (!data || Object.keys(data).length === 0) {
        console.warn("Data not ready yet.");
        return;
      }
      handleDownloadPDF();
    },
    handlePrint,
  }));

  return (
    <div>
      {loading && <Loader />}

      <div
        id="pdf-content"
        className="insurance_contr"
        style={{ display: "none" }}
      >
        {/* Preview section (optional - hidden by default) */}
        <div className="part1" id="part1">
          <h3>Driving License Preview</h3>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {DrivingLicenseImg ? (
              <div style={{ textAlign: "center" }}>
                <img
                  src={`${APL_LINK}assets/userlicence/${DrivingLicenseImg}`}
                  alt="Driving License"
                  style={{
                    width: "300px",
                    height: "auto",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                  }}
                />
                <p style={{ fontSize: "10px", margin: "5px 0" }}>
                  Name: {data?.first_name + " " + data?.last_name} | Car:{" "}
                  {data?.car_data[0]?.car_tagline}
                </p>
              </div>
            ) : (
              <p>No driving license image available</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default DrivingLicenseDownload;
